import { render, staticRenderFns } from "./update-paperpile-details.html?vue&type=template&id=31acc508&scoped=true&"
import script from "./update-paperpile-details.js?vue&type=script&lang=js&"
export * from "./update-paperpile-details.js?vue&type=script&lang=js&"
import style0 from "./update-paperpile-details.scss?vue&type=style&index=0&id=31acc508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31acc508",
  null
  
)

export default component.exports